import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Joboffer from "../FormDetails/Joboffer";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import DenaveJobInfo from "../FormDetails/DenaveJobInfo";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { useNavigate } from "react-router-dom";

const HrEmployeeApproval = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const navigate = useNavigate();

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">HR Approval List </h3>
            <br />
          </div>
          <div>
            <div
              className="InnerDetailPart"
              style={{
                display: "flex",
                // alignItems: "center",
                gap: "20px",
                background: "rgb(255, 223, 213)",
                padding: "20px 10px 0px",
                borderRadius: "5px",
                marginBottom: "5px",
              }}
            >
              <div className="">
                <button
                  className=""
                  style={{
                    padding: "3px 7px",
                    background: "rgb(239, 77, 57)",
                    color: "white",
                    fontSize: "15px",
                    borderRadius: "6px",
                  }}
                  onClick={(e) => {
                    navigate("/hrapprovallist");
                  }}
                >
                  {"Back"}
                  <span></span>
                </button>
              </div>
              <div className="LOGO" style={{ width: "25px", height: "25px" }}>
                <img src={profile2} style={{ width: "25px", height: "25px" }} />
              </div>
              <p className="EMpCODER">
                <span>
                  {
                    state?.HRonboardingDatas?.HRonboardingDatas?.basic_info
                      ?.first_name
                  }
                  &nbsp;
                  {
                    state?.HRonboardingDatas?.HRonboardingDatas?.basic_info
                      ?.first_name
                  }
                </span>
              </p>
            </div>
            <DenaveJobInfo />
          </div>
        </div>
      </div>
    </>
  );
};

export default HrEmployeeApproval;
